import {
  MALL_MYPAGE_PATH,
  MALL_ORDERS_PATH,
  MALL_SHIPPING_PATH,
  MALL_WISHLIST_PATH,
} from '@/constants/mall'

/** 마이페이지 사이드 메뉴 — 그누보드/영카트형 워딩 */
export interface MallMyNavItem {
  label: string
  to: string
  exact?: boolean
}

export interface MallMyNavGroup {
  title: string
  items: MallMyNavItem[]
}

export const MALL_MY_CLAIMS_PATH = `${MALL_MYPAGE_PATH}/claims`
export const MALL_MY_STATEMENTS_PATH = `${MALL_MYPAGE_PATH}/statements`
export const MALL_MY_REVIEWS_PATH = `${MALL_MYPAGE_PATH}/reviews`
export const MALL_MY_INQUIRIES_PATH = `${MALL_MYPAGE_PATH}/inquiries`
export const MALL_MY_CONSULTS_PATH = `${MALL_MYPAGE_PATH}/consults`
export const MALL_MY_CONSULT_WRITE_PATH = `${MALL_MY_CONSULTS_PATH}/write`
export const MALL_MY_PROFILE_PATH = `${MALL_MYPAGE_PATH}/profile`

export const MALL_MY_NAV: MallMyNavGroup[] = [
  {
    title: '쇼핑정보',
    items: [
      { label: '주문내역', to: MALL_ORDERS_PATH },
      { label: '취소/반품/환불', to: MALL_MY_CLAIMS_PATH },
      { label: '거래명세서', to: MALL_MY_STATEMENTS_PATH },
    ],
  },
  {
    title: '나의 활동',
    items: [
      { label: '문의 내역', to: MALL_MY_CONSULTS_PATH },
      { label: '구매후기', to: MALL_MY_REVIEWS_PATH },
      { label: '찜하기', to: MALL_WISHLIST_PATH },
    ],
  },
  {
    title: '회원정보',
    items: [
      { label: '회원정보수정', to: MALL_MY_PROFILE_PATH },
      { label: '배송지관리', to: MALL_SHIPPING_PATH },
      { label: '고객센터', to: '/mall/help/guide' },
    ],
  },
]
